import React from "react";
import { Button, Stack, Tooltip, Typography } from "@mui/material";
import { Check, Info } from "@mui/icons-material";
import { CommonDialog } from "./CommonDialog";

interface ConfirmationPendingModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Confirma a consulta (proposed → booked ou pending → booked). */
  onConfirm: () => Promise<void>;
  loadingConfirm?: boolean;
}

/**
 * Modal para consultas sem FluxPay ativo que aguardam confirmação da clínica
 * (agenda externa ou interna). Sem fluxo de cobrança/pagamento.
 */
export const ConfirmationPendingModal: React.FC<
  ConfirmationPendingModalProps
> = ({ isOpen, onClose, onConfirm, loadingConfirm = false }) => {
  const handleConfirmClick = async () => {
    await onConfirm();
    onClose();
  };

  return (
    <CommonDialog isOpen={isOpen} handleClose={onClose}>
      <Stack direction="column" spacing={3} alignItems="center" p={2}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Info sx={{ fontSize: 40, color: "info.main" }} />
          <Typography
            variant="h6"
            fontWeight={500}
            sx={{ color: "neutral1000.main" }}
          >
            Pendente de Confirmação
          </Typography>
        </Stack>

        <Typography variant="subtitle2" textAlign="center">
          Esta consulta aguarda confirmação da clínica. Confirme apenas se o
          agendamento estiver correto e validado.
        </Typography>

        <Tooltip title="Confirmar consulta agendada">
          <span>
            <Button
              variant="contained"
              sx={{ color: "neutral0.main" }}
              startIcon={<Check />}
              onClick={handleConfirmClick}
              disabled={loadingConfirm}
            >
              Confirmar consulta
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </CommonDialog>
  );
};
